import { chooseImageSource } from '../utils/testable-utils';

export default class LazyLoadManager {
  constructor() {
    this.observer = null;
    this.support = { avif: false, webp: false };
  }

  async init() {
    this.support = {
      avif: await this.checkFormat('data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYx'),
      webp: await this.checkFormat('data:image/webp;base64,UklGRiIAAABXRUJQVlA4TAYAAAAvAAAAAA=='),
    };

    document.documentElement.classList.toggle('avif', this.support.avif);
    document.documentElement.classList.toggle('webp', this.support.webp);
    this.observeImages();
  }

  checkFormat(dataUri) {
    return new Promise((resolve) => {
      const image = new Image();
      image.onload = () => resolve(image.width > 0 && image.height > 0);
      image.onerror = () => resolve(false);
      image.src = dataUri;
    });
  }

  observeImages() {
    const images = document.querySelectorAll('img[data-src]');

    if (!('IntersectionObserver' in window)) {
      images.forEach((image) => this.loadImage(image));
      return;
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.loadImage(entry.target);
          this.observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px 0px', threshold: 0.01 });

    images.forEach((image) => this.observer.observe(image));
  }

  loadImage(image) {
    let sources = null;

    if (image.dataset.sources) {
      try {
        sources = JSON.parse(image.dataset.sources);
      } catch (_error) {
        sources = null;
      }
    }

    const selectedSource = chooseImageSource(sources, this.support);

    if (selectedSource) {
      image.srcset = selectedSource;
    }

    if (image.dataset.src) {
      image.src = image.dataset.src;
    }

    image.addEventListener('load', () => image.classList.add('is-loaded'), { once: true });
    image.removeAttribute('data-src');
  }

  destroy() {
    this.observer?.disconnect();
  }
}
